import _get from 'lodash/get';
import { Documentation, useEdmDocumentationQuery } from 'graphql-common';

type Args = {
  id: string;
  isViewLocked?: boolean;
  skip?: boolean;
};

export default function useEdmDocumentationQueryHook({
  id,
  isViewLocked = false,
  skip = false,
}: Args) {
  const query = useEdmDocumentationQuery({
    fetchPolicy: 'cache-and-network',
    skip: skip || !id,
    variables: { id, isViewLocked },
  });

  const { refetch, error, loading, data: queryData, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;
  const documentation = _get(data, 'data') as Documentation;

  return {
    data: documentation,
    loading,
    error,
    refetch,
    firstLoading,
  };
}
